<div class="list-header">
  <div class="left">
    <div class="title">
      이 책에 남긴 <span class="count">{{ _items.length }}</span
      >개의 메모가 있습니다.
    </div>
  </div>
  <div class="right">
    <button
      class="select-all-button"
      [class.is-active]="
        _selectedItemCount > 0 && _selectedItemCount === _items.length
      "
      (click)="_onSelectAllButtonClick()"
    >
      전체 선택<sui-icon name="체크"></sui-icon>
    </button>
    <select
      sui-select
      [(ngModel)]="_selectedSortType"
      (ngModelChange)="_onSortTypeChange()"
    >
      <option *ngFor="let sortType of _sortTypes" [value]="sortType">
        {{ sortType }}
      </option>
    </select>
  </div>
</div>
<div
  class="list isMyBookMode"
  #listContainer
  [class.selection-mode]="_selectedItemCount > 0"
>
  <div
    class="list-item"
    *ngFor="let item of _items; index as i"
    [class.is-selected]="item.selected"
    [attr.data-memo-id]="item.id"
  >
    <div class="memo">
      <viewer-memo
        [menu]="menu"
        [menuData]="{ item: item }"
        [content]="item.content"
        [createdAt]="item.created_at"
        [updatedAt]="item.updated_at ?? item.created_at"
        [attr.data-memo-id]="item.id"
        [isSingleMode]="_isSingleMode"
      >
        <button
          sui-icon-button
          viewer-memo-top-button
          class="share-button"
          (click)="_onShareButtonClick(item)"
          [disabled]="item.is_blinded"
        >
          <sui-icon name="공유-1" type="solid"></sui-icon>
        </button>

        <viewer-memo-caution *ngIf="item.is_blinded">
          <p class="block-tag">신고로 인해 숨김 처리된 메모입니다.</p>
        </viewer-memo-caution>

        <viewer-memo-tag *ngIf="item.source"
          >{{ item.copied_at | date : 'y.MM.dd. HH:mm' }} |
          {{ item.source }}님의 댓글 복사</viewer-memo-tag
        >
        <viewer-memo-actions>
          <button class="icon-button" disabled *ngIf="_groupId !== undefined">
            <sui-icon name="추천"></sui-icon>
            {{ item.like_count }}
          </button>
          <button class="icon-button" disabled *ngIf="_groupId !== undefined">
            <sui-icon name="복사" type="solid"></sui-icon>
            {{ item.copy_count }}
          </button>
          <!-- 댓글 추가 -->
          <button
            class="icon-button"
            (click)="_onClickMemoCommentButton(item)"
            *ngIf="_groupId !== undefined"
            [disabled]="item.is_blinded"
          >
            <sui-icon name="댓글" class="comment"></sui-icon>
            {{ item.comment_count }}
          </button>
          <button
            class="text-button"
            (click)="_onItemClick(item)"
            [disabled]="item.is_blinded"
          >
            {{ _focusedMemoId === item.id ? '본문 보기 해제' : '본문 보기' }}
          </button>
        </viewer-memo-actions>
      </viewer-memo>
      <viewer-icon-checkbox class="checkbox" [class.is-selected]="item.selected"
        ><input
          type="checkbox"
          [(ngModel)]="item.selected"
          (ngModelChange)="_onItemSelectionChange()"
      /></viewer-icon-checkbox>
    </div>
  </div>
</div>
<div class="bottom-menu" [class.is-active]="_selectedItemCount > 0">
  <div class="selection-count">
    총 <span>{{ _selectedItemCount }}</span
    >개 선택
  </div>
  <div class="buttons">
    <button
      sui-box-button
      varSize="medium48::medium40::medium40"
      (click)="_onClickSelectCancelButton()"
    >
      선택취소</button
    ><button
      sui-solid-button
      varSize="medium48::medium40::medium40"
      (click)="_onDeleteSelectedItemsButtonClick()"
    >
      삭제하기
    </button>
  </div>
</div>

<ng-template #menu let-item="item">
  <sui-menu cdkMenu>
    <button
      sui-menu-item
      cdkMenuItem
      (click)="_onEditMenuClick(item)"
      *ngIf="!item.is_blinded"
    >
      수정하기
    </button>
    <button sui-menu-item cdkMenuItem (click)="_onDeleteMenuClick(item)">
      삭제하기
    </button>
    <button
      sui-menu-item
      cdkMenuItem
      (click)="_onExportMenuClick(item)"
      *ngIf="!_isCommentaryEditorMode && !item.is_blinded"
    >
      내보내기
    </button>
    <button
      sui-menu-item
      cdkMenuItem
      (click)="_onCopyMenuClick(item)"
      *ngIf="!item.is_blinded"
    >
      복사하기
    </button>
  </sui-menu>
</ng-template>
